package org.catharsis.spendtel.core.platform

import kotlinx.browser.document
import kotlinx.browser.window

actual fun shareText(title: String, text: String): Boolean {
    val navigator = window.navigator.asDynamic()
    if (navigator.share != undefined) {
        val shareData = js("{}")
        shareData.title = title
        shareData.text = text
        navigator.share(shareData).unsafeCast<kotlin.js.Promise<Unit>>().catch { /* user cancelled */ }
        return true
    }

    return copyTextToClipboard(text)
}

actual fun sharePng(fileName: String, pngBytes: ByteArray): Boolean {
    downloadPng(fileName, pngBytes.toBlob())
    return false
}

private fun ByteArray.toBlob(): dynamic {
    val length = size
    val buffer = js("new Uint8Array(length)")
    for (index in indices) {
        buffer[index] = this[index]
    }
    return js("new Blob([buffer], { type: 'image/png' })")
}

private fun copyTextToClipboard(text: String): Boolean {
    val clipboard = window.navigator.asDynamic().clipboard
    if (clipboard != undefined && clipboard.writeText != undefined) {
        clipboard.writeText(text)
        return false
    }

    val textarea = document.createElement("textarea") as org.w3c.dom.HTMLTextAreaElement
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body?.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body?.removeChild(textarea)
    return false
}

private fun downloadPng(fileName: String, blob: dynamic) {
    val url = js("URL.createObjectURL(blob)") as String
    val anchor = document.createElement("a") as org.w3c.dom.HTMLAnchorElement
    anchor.href = url
    anchor.download = fileName
    document.body?.appendChild(anchor)
    anchor.click()
    document.body?.removeChild(anchor)
    js("URL.revokeObjectURL(url)")
}
